<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1></h1>
<p><em>Oh! I have slipped the surly bonds of Earth.</em></p>
<p><em>And danced the skies on laughter-silvered wings;</em></p>
<p><em>Sunward I’ve climbed, and joined the tumbling mirth</em></p>
<p><em>Of sun-split clouds, and done a hundred things</em></p>
<p><em>You have not dreamed of wheeled and soared and swung</em></p>
<p><em>High in the sunlit silence. Hov’ring there,</em></p>
<p><em>I’ve chased the shouting wind along, and flung</em></p>
<p><em>My eager craft through footless halls of air.</em></p>
<br/>
<p>John Gillespie Magee, Jr 1941</p>
<br/>
<p style="text-indent: 00em;"><em>Flight 3456 standby, number 157 in sequence for start-up, call back tomorrow.</em></p>
<br/>
<p>Delhi Air traffic control, 2013</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?4ea62713